import InfoCircle from '@/assets/icons/info-circle.svg?react';
import styles from './call-metric-card.module.scss';
import { Card, Tooltip, Flex } from 'antd';
import ArrowTopRight from '@/assets/icons/arrow-up-right.svg?react';
import ArrowDownRight from '@/assets/icons/arrow-down-right.svg?react';
import Icon from '@ant-design/icons';
import { Button } from '../button/button';

interface CallMetricCardProps {
  title: string;
  tooltipContent: string;
  currentPercent: string;
  change: number;
  calls: string;
  description: string;
  arrowColor?: string;
  onClick: () => void;
  buttonClassName?: string;
}

export const CallMetricCard = ({
  title,
  tooltipContent,
  currentPercent,
  change,
  description,
  calls,
  arrowColor,
  onClick,
  buttonClassName,
}: CallMetricCardProps) => {
  const isPositive = change > 0;
  const ArrowIcon = isPositive ? ArrowTopRight : ArrowDownRight;

  return (
    <Card className={styles.container}>
      <Button buttonVariant="card" className={buttonClassName} onClick={onClick}>
        <Flex gap={7} className={styles.titleContainer}>
          <p className={styles.title}>{title}</p>
          <Tooltip title={tooltipContent} className={styles.tooltip}>
            <Icon
              component={() => <InfoCircle fill="none" height="18" width="18" />}
              className={styles.tooltipIcon}
            />
          </Tooltip>
        </Flex>
        <Flex gap={3}>
          <p className={styles.currentPercent}>{currentPercent}</p>
          <Flex style={{ color: arrowColor }} align="flex-start">
            <Icon component={() => <ArrowIcon className={styles.arrowIcon} />} />
            <p className={styles.change}>{`${change}%`}</p>
          </Flex>
        </Flex>
        <p className={styles.description}>
          <span className={styles.calls}>{calls}</span> {description}
        </p>
      </Button>
    </Card>
  );
};
